import { BaseModel } from "sjs-base-model";

export default class CastAgencyLightModel extends BaseModel {
  public readonly slug: string = "";
  public readonly name: string = "";
  public readonly logo: string | null = null;

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<CastAgencyLightModel>) {
    super();

    this.update(data);
  }
}
